import { Components } from "react-markdown";

// Mirrors firewalla.web's sharedMarkdownComponents: links from CMS-style
// config copy should open in a new tab rather than navigate away.
export const sharedMarkdownComponents: Components = {
  a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />,
};
